import {
  Box,
  Chip,
  IconButton,
  Tooltip,
  CircularProgress
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

type LockedStatusChipProps = {
  onUnlock: (e: React.MouseEvent) => void;
  isPending: boolean;
  isDisabled?: boolean;
  disabledTooltip?: string;
  labels: {
    locked: string;
    unlockButton: string;
  };
};

export const LockedStatusChip = ({
  onUnlock,
  isPending,
  isDisabled = false,
  disabledTooltip,
  labels
}: LockedStatusChipProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isDisabled) {
      onUnlock(e);
    }
  };

  const tooltipTitle =
    isDisabled && disabledTooltip ? disabledTooltip : labels.unlockButton;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        backgroundColor: 'action.disabledBackground',
        borderRadius: 2,
        pl: 1.5,
        pr: 0.5,
        py: 0.25,
        height: 32
      }}
    >
      <LockIcon
        sx={{
          fontSize: 16,
          color: 'text.secondary'
        }}
      />
      <Chip
        label={labels.locked}
        size="small"
        sx={{
          backgroundColor: 'transparent',
          color: 'text.secondary',
          fontWeight: 500,
          fontSize: '0.8125rem',
          height: 'auto',
          '& .MuiChip-label': {
            px: 0.5
          }
        }}
      />
      <Tooltip title={tooltipTitle} arrow>
        <span>
          <IconButton
            size="small"
            onClick={handleClick}
            disabled={isPending || isDisabled}
            sx={{
              ml: 0.5,
              p: 0.5,
              color: 'primary.main',
              backgroundColor: 'background.paper',
              border: 1,
              borderColor: 'divider',
              borderRadius: 1.5,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                borderColor: 'primary.main',
                transform: 'scale(1.05)'
              },
              '&:disabled': {
                backgroundColor: 'action.disabledBackground',
                color: 'action.disabled'
              }
            }}
          >
            {isPending ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <LockOpenIcon sx={{ fontSize: 16 }} />
            )}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};
